import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '../../../components/ui/table';
import { FileSpreadsheet } from 'lucide-react';
import type { SupplierUploadTracking } from '../../../lib/api/barratt';
import { datasetLabel, formatDayTime, formatOtif, formatCount } from '../uploadCycle';
import { UploadTableSkeleton, UploadTableEmpty } from './UploadTableStates';

interface UploadedTableProps {
  rows: SupplierUploadTracking[];
  loading: boolean;
  emptyMessage: string;
}

const COLUMNS = 7;

/** "Suppliers did upload": one row per supplier × dataset that has a file in. */
export default function UploadedTable({ rows, loading, emptyMessage }: UploadedTableProps) {
  return (
    <Table data-testid="uploaded-table">
      <TableHeader>
        <TableRow>
          <TableHead>Supplier</TableHead>
          <TableHead>Dataset</TableHead>
          <TableHead>Uploaded</TableHead>
          <TableHead>File</TableHead>
          <TableHead className="text-right">Records</TableHead>
          <TableHead className="text-right">OTIF %</TableHead>
          <TableHead className="text-right">NCRs</TableHead>
        </TableRow>
      </TableHeader>
      {loading ? (
        <UploadTableSkeleton columns={COLUMNS} />
      ) : rows.length === 0 ? (
        <UploadTableEmpty columns={COLUMNS} message={emptyMessage} />
      ) : (
        <TableBody>
          {rows.map((row) => (
            <TableRow key={row.id}>
              <TableCell className="font-medium">{row.supplier_name || `Supplier ${row.supplier}`}</TableCell>
              <TableCell>{datasetLabel(row)}</TableCell>
              <TableCell className="text-muted-foreground">{formatDayTime(row.uploaded_at)}</TableCell>
              <TableCell>
                {row.file_name ? (
                  <span className="inline-flex items-center gap-1.5 text-sm">
                    <FileSpreadsheet className="h-4 w-4 shrink-0 text-muted-foreground" />
                    <span className="max-w-[16rem] truncate" title={row.file_name}>{row.file_name}</span>
                  </span>
                ) : (
                  <span className="text-muted-foreground">—</span>
                )}
              </TableCell>
              <TableCell className="text-right">{formatCount(row.records_count)}</TableCell>
              <TableCell className="text-right">{formatOtif(row.otif_pct)}</TableCell>
              <TableCell className="text-right">{formatCount(row.ncr_count)}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      )}
    </Table>
  );
}
